import React from 'react'
import TextBody from 'components/TextBody'
import { STYLES_COLOR } from 'modules/styles/constants/index.cjs'
import { View } from 'components/View'
import intervalToDuration from 'date-fns/fp/intervalToDuration'
import useSelector from 'modules/component/utils/hooks/useSelector.js'
import isSmallScreenViewportSelect from 'modules/viewport/selectors/is-small-screen'

const INTERVAL = 1000

export function CountdownSection ({ end }) {
  const isSmallScreen = useSelector(isSmallScreenViewportSelect)
  const [start, setStart] = React.useState(new Date())
  const hasEnded = start > end
  const duration = hasEnded
    ? {
        days: 0,
        hours: 0,
        minutes: 0,
        seconds: 0
      }
    : intervalToDuration({
      start,
      end
    })

  React.useEffect(() => {
    let interval
    if (!hasEnded) {
      interval = setInterval(() => {
        setStart(new Date())
      }, INTERVAL)
    }
    return () => clearInterval(interval)
  }, [])

  return (
    <View
      p={isSmallScreen ? '1.27em' : '2.39em'}
      bgc='rgba(255, 255, 255, 0.11)'
      row
      style={{
        gap: isSmallScreen ? '2.18em' : '4.49em',
        borderRadius: '0.625em'
      }}
    >
      <View centered>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1.75em' : '3em'}
          fw='700'
        >{duration.days}
        </TextBody>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1em' : '1.375em'}
          mt
          fw='500'
        >DAY
        </TextBody>
      </View>
      <View centered>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1.75em' : '3em'}
          fw='700'
        >{duration.hours}
        </TextBody>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1em' : '1.375em'}
          mt
          fw='500'
        >HOUR
        </TextBody>
      </View>
      <View centered>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1.75em' : '3em'}
          fw='700'
        >{duration.minutes}
        </TextBody>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1em' : '1.375em'}
          mt
          fw='500'
        >MIN
        </TextBody>
      </View>
      <View centered>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1.75em' : '3em'}
          fw='700'
        >{duration.seconds}
        </TextBody>
        <TextBody
          c={STYLES_COLOR.WHITE}
          fs={isSmallScreen ? '1em' : '1.375em'}
          mt
          fw='500'
        >SEC
        </TextBody>
      </View>
    </View>
  )
}
